import { Box, Typography } from "@mui/material";
import React from "react";
import whattodo from "../../assets/images/What we do.png";
import { LazyLoadImage } from "react-lazy-load-image-component";
import Orangelogo from "../../assets/images/Orangelogo.png";
import Knowmorebtn from "../../components/button/Knowmorebtn";
import StoryTwoImage from "../../assets/images/StoryImageTwo.png";

const OurStoryTwo = () => {
  return (
    <Box
      sx={{
        maxWidth: { xs: "100%", md: "1440px" },
        margin: "0 auto",
        marginTop: "0",
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        padding: { xs: "0rem 1.8rem", md: "0rem 3rem" },
      }}
    >
      <Box
        sx={{
          width: { xs: "100%", md: "50%" },
        }}
      >
        <Typography
          sx={{
            fontFamily: "Montserrat",
            marginTop: "1.2rem",
            marginBottom: "1.2rem",
          }}
        >
          Our agile teams and industry stalwarts bring deep expertise across digital, e-commerce, marketing, sales, retail, market entry, brand, and media. Leveraging multi-source data and advanced technologies, we help businesses enhance efficiency, maximize ROI, and unlock new growth opportunities.
        </Typography>
        <Typography
          sx={{
            fontFamily: "Montserrat",
            marginTop: "1.2rem",
            marginBottom: "1.2rem",
          }}
        >
          From optimizing operations to forecasting product potential, we craft bespoke strategies that propel businesses forward. Partner with Inteliphyle to transform uncertainty into opportunity and redefine success in the era of data-driven decision-making.
        </Typography>
      </Box>

      <Box
        sx={{
          width: { xs: "100%", md: "50%" },
          display: "flex",
          justifyContent: "end",
          alignItems: {xs: "center", md:"end"},
          flexDirection: "column",
        }}
      >
        <Box
          sx={{
            width: { xs: "80%", md: "34rem" },
          }}
        >
          <LazyLoadImage
            src={StoryTwoImage}
            effect="blur"
            width="100%"
            height="100%"
          />
        </Box>
      </Box>
    </Box>
  );
};

export default OurStoryTwo;
